import { createTheme, CssBaseline } from '@mui/material';
import './App.css';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import RoutesComponent from './components/Navigation/Routes';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const theme = createTheme({});
  
  // Custom close function to prevent the error
  const customCloseButton = ({ closeToast }) => (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
          closeToast && closeToast();
        } catch (error) {
          console.warn('Toast close error:', error);
        }
      }}
      style={{
        background: 'transparent',
        border: 'none',
        color: 'white',
        fontSize: '16px',
        cursor: 'pointer',
        padding: '0 5px'
      }}
    >
      ×
    </button>
  );
  
  return (
    <>
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <BrowserRouter>
        <RoutesComponent/>
        <ToastContainer 
          position='top-right' 
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          closeButton={customCloseButton}
        />
      </BrowserRouter>
    </ThemeProvider>
    </>
  );
}

export default App;
